import { Component, Input, OnInit } from '@angular/core';

/**
 * @deprecated()
 */
@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss']
})
export class LoadingIndicatorComponent implements OnInit {
  @Input() size: string = 'lg'
  @Input() position: string = 'absolute'
  @Input() message: string = ''

  get spinnerClass(): string {
    return `loader--${this.size}`
  }

  get loaderClass(): string {
    return `loader--${this.position}`
  }

  constructor() { }

  ngOnInit(): void {
  }

}
